export default {
  methods: {
    updateFont(font, id) {
      this.$store.commit('update_font', {
        value: font.value,
        url: font.url,
        id: id
      })
    },
    updateStyle(key, value) {
      this.$store.commit('update_style', {
        key: key,
        value: value
      })
    },
    updateOptions(key, value, id){
      this.$store.commit('update_options', {
        id: id,
        key: key,
        value: value
      })
    },
    updateAnimation(value) {
      this.$store.commit('update_animation', {
        value: value
      })
    },
    updateTransition(value) {
      this.$store.commit('update_transition', {
        value: value
      })
    },
    updateRotate(value, id) {
      this.$store.commit('update_rotate', {
        value: value,
        i: id
      })
    }
  }
}
